// extracted by mini-css-extract-plugin
export default {"container":"Label_container__eGSB3","required":"Label_required__aVd89"};